import React from 'react';
import '../styles/CommercialPage.css';

const CommercialPage = () => {
  const services = [
    {
      title: "Office Spaces",
      description: "Create a pristine work environment that boosts productivity and impresses clients.",
      features: ["Daily cleaning maintenance", "Deep carpet cleaning", "Window washing", "Sanitization of high-touch surfaces"]
    },
    {
      title: "Retail Spaces",
      description: "Keep your retail space spotless to enhance customer experience and product presentation.",
      features: ["Floor maintenance", "Display cleaning", "Restroom sanitation", "Entrance & window cleaning"]
    }
  ];

  const benefits = [
    {
      title: "Customized Cleaning Plans",
      description: "We develop tailored cleaning programs that match your specific needs and schedule."
    },
    {
      title: "Trained Professionals",
      description: "Our staff undergoes rigorous training in the latest cleaning techniques and safety protocols."
    },
    {
      title: "Green Cleaning",
      description: "Eco-friendly cleaning solutions that are tough on dirt but gentle on the environment."
    },
    {
      title: "Quality Assurance",
      description: "Regular inspections and feedback systems ensure consistent, high-quality service."
    }
  ];

  return (
    <div className="commercial-page">
      {/* Hero Section */}
      <section className="commercial-hero">
        <div className="hero-content">
          <h1>Professional Commercial Cleaning Solutions</h1>
          <p>Transform your business space into a pristine environment that reflects your professional standards.</p>
          <button className="cta-button">Get a Custom Quote</button>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <div className="section-content">
          <h2>Why Choose Bubble & Maple</h2>
          <div className="features-grid">
            <div className="feature">
              <h3>15+ Years Experience</h3>
              <p>Trusted by businesses across Cleveland for over a decade.</p>
            </div>
            <div className="feature">
              <h3>Certified Teams</h3>
              <p>Professionally trained and background-checked staff.</p>
            </div>
            <div className="feature">
              <h3>24/7 Availability</h3>
              <p>Flexible scheduling to minimize business disruption.</p>
            </div>
            <div className="feature">
              <h3>Guaranteed Satisfaction</h3>
              <p>We're not satisfied until you're delighted with our service.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="section-content">
          <h2>Our Commercial Services</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul>
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="section-content">
          <h2>The Bubble & Maple Advantage</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <div className="section-content">
          <h2>Ready to Transform Your Space?</h2>
          <p>Get in touch for a customized cleaning solution that meets your business needs.</p>
          <div className="cta-buttons">
            <button className="primary-button">Request a Quote</button>
            <button className="secondary-button">View Our Portfolio</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CommercialPage; 